<div *ngIf="hasChannelNotConfigured()" class="channels-setup-message alert alert-info">
  <my-global-icon iconName="tip"></my-global-icon>

  <div>
    <div i18n>Some of your channels are not fully set up. Make them welcoming and explicit about what you publish by adding a <strong>banner</strong>, an <strong>avatar</strong> and a <strong>description</strong>.</div>
    <a *ngIf="!hideLink" class="channels-settings-link" routerLink="/my-library/video-channels" i18n>Set up my channels</a>
  </div>
</div>
